/**
 * @file Renders the button that deletes the current entity item.
 */
import { useState } from "react";
import { Button } from "antd";
import { StopOutlined } from "@ant-design/icons";
import type { ButtonProps } from "antd";

import { W1 } from "@components/Constants";

const LABEL_DELETE = "Delete";

type Props = {
  title?: string;
  onDelete: () => Promise<unknown>;
} & Omit<ButtonProps, "title" | "onClick" | "loading">;

/**
 * Renders a delete button that shows a loading state while the
 * delete request is in flight.
 */
const DeleteButton = ({
  title = LABEL_DELETE,
  onDelete,
  ...buttonProps
}: Props): JSX.Element => {
  const [ isLoading, setIsLoading ] = useState(false);

  /**
   * Runs the delete request and clears the loading state when it
   * settles.
   */
  const onClick = () => {
    setIsLoading(true);
    onDelete()
      .then(() => setIsLoading(false));
  };

  return (
    <div style={{ textAlign: "center", marginTop: W1 - 6 }}>
      <Button
        danger
        type="text"
        icon={<StopOutlined />}
        onClick={onClick}
        loading={isLoading}
        {...buttonProps}
      >
        {title}
      </Button>
    </div>
  );
};

export default DeleteButton;
